"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styles = require("../styles");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var Upload = function Upload(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    colorProp = _ref$color === void 0 ? '#181B32' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    ignoreColor = _ref.ignoreColor,
    _ref$animation = _ref.animation,
    animation = _ref$animation === void 0 ? '' : _ref$animation;
  var color = !ignoreColor ? colorProp : undefined;
  return /*#__PURE__*/_react["default"].createElement(_styles.Svg, {
    className: "".concat(className, " ").concat(animation),
    width: size,
    height: size,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M6.57 8.016L9.4 5.188v8.092c0 .332.268.596.6.596.332 0 .6-.268.6-.596V5.184l2.828 2.828a.603.603 0 00.424.176.599.599 0 00.424-1.02L10.423 3.32a.619.619 0 00-.848 0L5.723 7.172a.599.599 0 000 .844.604.604 0 00.848 0z",
    fill: color
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M16.183 13.5c-.332 0-.6.268-.6.596 0 .856-.696 1.556-1.556 1.556h-8.06a1.56 1.56 0 01-1.556-1.556.596.596 0 00-.6-.596c-.332 0-.6.268-.6.596a2.757 2.757 0 002.752 2.752h8.064a2.757 2.757 0 002.752-2.752.592.592 0 00-.596-.596z",
    fill: color
  }));
};
var _default = exports["default"] = Upload;